module.exports = __webpack_public_path__ + "static/media/71.4ac3997c.jpg";